import { Injectable, inject } from '@angular/core';

import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';

import { LDFeatureFlags } from './flags';
import { LaunchDarklyFlagManagerService } from './launch-darkly-flag-manager.service';

@Injectable({ providedIn: 'root' })
export class LaunchDarklyTrackingService {
    private readonly launchDarklyService = inject(LaunchDarklyService);
    private readonly launchDarklyFlagManagerService = inject(LaunchDarklyFlagManagerService);

    /**
     * Use this function if you want to check your flag's existence in the current Launch Darkly client context before tracking.
     *
     * @param flag
     * @param key
     * @param data
     * @param metricValue
     * @returns
     */
    trackByContext(flag: LDFeatureFlags, key: string, data?: unknown, metricValue?: number) {
        if (!this.launchDarklyFlagManagerService.isFlagInContext(flag)) {
            return;
        }
        this.launchDarklyService.client.track(key, data, metricValue);
    }

    /**
     * Use this function if you want to check your flag's existence in the localstorage before tracking.
     *
     * @param flag
     * @param key
     * @param data
     * @param metricValue
     * @returns
     */
    trackByLocalStorage(flag: LDFeatureFlags, key: string, data?: unknown, metricValue?: number) {
        if (!this.launchDarklyFlagManagerService.isFlagInLocalStorage(flag)) {
            return;
        }
        this.launchDarklyService.client.track(key, data, metricValue);
    }
}
